// extracted by mini-css-extract-plugin
export var numberInputContainer = "_4q-0";
export var startPickingButton = "_4q-1";